var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLeaderboardOutline = function SvgLeaderboardOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4 19h4v-8H4zm6 0h4V5h-4zm6 0h4v-6h-4zM2 19v-8q0-.825.587-1.412A1.93 1.93 0 0 1 4 9h4V5q0-.824.588-1.412A1.93 1.93 0 0 1 10 3h4q.825 0 1.412.587Q16 4.176 16 5v6h4q.824 0 1.413.588Q22 12.175 22 13v6q0 .824-.587 1.413A1.93 1.93 0 0 1 20 21H4q-.824 0-1.412-.587A1.93 1.93 0 0 1 2 19"
  })));
};
export default SvgLeaderboardOutline;